export default __webpack_public_path__ + "static/media/13.043bf65e.webp";